import { HeaderLinkTitle } from '@/utils/enums';
import { Dialog, Transition, TransitionChild } from '@headlessui/react';
import { Button, Typography } from '@pw-tech/omni-ui';
import { MenuIcon, XIcon } from 'lucide-react';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import React, { Fragment, useState } from 'react';
import { LinkProps } from '../../schema';

const MenuDrawer = ({
  links,
  handleLinkClick,
  logo,
  handleLogoClick,
  handleLoginBtnClick,
  loginButton,
}: {
  links: LinkProps[];
  loginButton?: boolean;
  handleLinkClick: (ur: string, title: string) => void;
  logo: string;
  handleLogoClick: () => void;
  handleLoginBtnClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const pathname = usePathname();
  const [openSidebar, setSidebarOpen] = useState(false);

  const toggleMenu = () => {
    setSidebarOpen(prev => !prev);
  };

  const initialPathname = pathname?.split('/')[1];

  return (
    <>
      <MenuIcon className="w-6 h-6 text-black" onClick={toggleMenu} />

      {openSidebar && <div className="fixed inset-0 z-[100] overflow-y-auto" id="modalOverlay" />}
      <Transition appear show={openSidebar} as={Fragment}>
        <Dialog as="div" onClose={() => {}}>
          <div className="fixed inset-0 z-[100] overflow-y-auto">
            <div className="flex h-full items-center justify-center text-center sm:items-start sm:justify-start lg:hidden">
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-600"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="ease-in duration-600"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <div className="w-[100vw] sm:w-[50vw] h-full relative transform overflow-hidden bg-white text-left align-middle shadow-xl transition-all">
                  <div className="flex justify-between px-3 pt-4 pb-2 items-center shadow">
                    <div className="flex items-center">
                      {logo && (
                        <Button variant="link" onClick={handleLogoClick}>
                          <Image
                            src={logo || ''}
                            width={128}
                            height={30}
                            alt="CuriousJr Logo"
                            unoptimized
                          />
                        </Button>
                      )}
                    </div>
                    <span className="w-7 h-7 cursor-pointer" onClick={toggleMenu}>
                      <XIcon />
                    </span>
                  </div>
                  <div className="flex flex-col justify-between h-lvh pb-14">
                    <div>
                      {links &&
                        links?.map((data: LinkProps, index: number) => (
                          <div
                            role="button"
                            tabIndex={0}
                            onClick={() => handleLinkClick(data?.url, data?.title)}
                            key={data?.title}
                            className="border-b border-[#EFEFEF] flex justify-between items-center p-4 cursor-pointer"
                          >
                            <div className="flex items-center gap-2">
                              {data.title === HeaderLinkTitle.ACTIVITY_KITS && (
                                <Image
                                  src="/v2/pendulum.svg"
                                  alt="Activity Kits Icon"
                                  width={20}
                                  height={20}
                                  className="object-contain"
                                  unoptimized
                                />
                              )}
                              <Typography variant="regular" weight="semi-bold" color="#1B2124">
                                {data.title || ''}
                              </Typography>
                            </div>
                          </div>
                        ))}
                    </div>
                    {loginButton && (
                      <a
                        href={initialPathname ? `/${initialPathname}/login` : '/login'}
                        id="login-register-btn-header-cjr"
                        className="w-full p-4 pb-8"
                      >
                        <Button variant="secondary" onClick={handleLoginBtnClick} fullWidth>
                          Login/Register
                        </Button>
                      </a>
                    )}
                  </div>
                </div>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default MenuDrawer;
